import axios from 'axios';
/**
 * Returns an array of query parameters from the url.
 * @return {Object} query parameters as a key/value pair
 */
export const DEFAULT_BRAND = "nw";
export function getQueryParams() {
  const {
    location: { search }
  } = document;
  const value = search.substring(1);
  const queryParams = {};
  const params = value.split('&');

  params.forEach((element) => {
    const [first, second] = element.split('=');

    if (first === '') {
      return;
    }
    queryParams[first] = second;
  });

  return queryParams;
}
/**
 * Retrieves the corresponding environment and brand from the hostname. 
 * environment. Default brand is set in DEFAULT_BRAND(nw).
 */
export const getBrandCodeDomain = () => {
  const BRAND_CODES = {
    "rbs.co.uk": "rbs",
    "natwest.com": "nw",
    "ulsterbank.co.uk": "ubn",
    "natwestinternational.com": "natwesti"
  };
  const brandCode = Object.keys(BRAND_CODES)
    .filter((item) => document.location.hostname.includes(item) === true)
    .map((item) => BRAND_CODES[item])[0];
    
  if(brandCode && brandCode !== "undefined"){
    return brandCode;
  }else{ 
    return DEFAULT_BRAND;
  }
};
// We are maintaining 3 letter brand code
export const getBrandCodeForMS = () => {
  const BRAND_CODES = {
    "rbs.co.uk": "rbs",
    "natwest.com": "nwb",
    "ulsterbank.co.uk": "ubn",
    "natwestinternational.com": "nwo"
  };
  const brandCode = Object.keys(BRAND_CODES)
    .filter((item) => document.location.hostname.includes(item) === true)
    .map((item) => BRAND_CODES[item])[0];
    
  if(brandCode && brandCode !== "undefined"){
    return brandCode;
  }else{ 
    return 'nwb';
  }
};

// Function to get the Device browser
export function getDeviceBrowser() {
  let os = navigator.userAgent;
  let browser;
  if (os.includes('Chrome') || os.includes('CriOS')) {
    browser = 'Chrome';
  } else if (os.includes('Safari')) {
    browser = 'Safari';
  } else {
    browser = 'Other';
  }
  return browser; 
}

// Validate the User, connect to internal Card reveal service and fetch the data from Datapower to UI
export const validateUserFetchCard = async (token) => {
  const headers = {
    'Access-Control-Allow-Origin': '*',
    'accept': 'application/json',
    'x-interaction-id': uuidv4(),
    'channel': 'MOB',
    'Content-Type': 'application/json',
  };
  const response = await axios.post(
      getEnvbasedAPI(),
      {
        "token": token,
        "brand": getBrandCodeForMS()
      },
      {"headers":headers}
  );
  return response.data;
};

//Provides the back to app depends upon the brand
export const getBackToAppLink = () => {

  let brand  = getBrandCodeDomain();
  let back_to_app = "https://personal.secure1.natwest.com/app/AppHome";
  if(brand === 'rbs'){
    back_to_app = "https://personal.secure1.rbs.co.uk/app/AppHome";
  }else if(brand === 'ubn'){
    back_to_app = "https://personal.secure1.ulsterbank.co.uk/app/AppHome";
  }else if(brand === 'natwesti'){
    back_to_app = "https://personal.secure1.natwestinternational.com/app/AppHome";
  }
   return back_to_app;
}

//Environment based API call
export const getEnvbasedAPI = () => {
  const environmentList = ['dev', 'qa', 'sit', 'nft'];
  let env = '';
  let getEnv = environmentList.filter((item) => document.location.hostname.includes(item) === true);
  if(getEnv.length > 0){
   env = getEnv[0];
  }
  if(env)
    return `https://${env}-openapi.natwest.com/debitcards/v1/fsso-validation`;
  else
    return 'https://openapi.natwest.com/debitcards/v1/fsso-validation';
};

//Generate UUID
export const uuidv4 = () => {
  // eslint-disable-next-line
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

export const getEnv = () => {
  const environmentList = ['dev', 'qa', 'sit', 'nft', 'local'];
  let env = '';
  let getEnv = environmentList.filter((item) => document.location.hostname.includes(item) === true);
  if(getEnv.length > 0){
    env = getEnv[0];
  }
  return env;
}